import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class UnrealisedGainsSummaryLookup extends ModelBase {
  
  public clientAccountID: string = "";

  public brokerAccountNumber: string = "";

  public instrument: string = "";

  public instrumentCode: string = "";

  public isinCode: string = "";

  public totalGrossNC: number | null = null;

  public portfolioBookPriceNC: number | null = null;

  public unrealisedGainNC: number | null = null;
}